import { useMemo } from 'react';

import { type ConversationAction } from '@atlassian/rovo-conversation-actions';

import { useViewPageRovoActions } from '@confluence/page-rovo-config-common/entry-points/useViewPageRovoActions.ts';

/**
 * Returns the list of nudge actions to register for the current edit page.
 * Only applicable to live docs (controlled by enableLiveDocNudges).
 * Returns [] if live doc nudges are not enabled.
 * The returned array is ready to pass directly to setNudges.
 */
export function useEditPageNudgeConfig(enableLiveDocNudges: boolean): ConversationAction[] {
	const viewPageRovoActions = useViewPageRovoActions();

	return useMemo(() => {
		if (!enableLiveDocNudges) return [];

		const audioBriefingAction = viewPageRovoActions.find(
			(a: { actionId: string }) => a.actionId === 'audio-briefing',
		)?.action as ConversationAction | undefined;

		return audioBriefingAction ? [audioBriefingAction] : [];
	}, [enableLiveDocNudges, viewPageRovoActions]);
}
